/**
 * Банкнотата в „Закрий" (рестото и „Смесено"): „+5 €" — сумата се ДОБАВЯ към
 * даденото в брой. Размерът (височина, заобляне) е на панела.
 */
export function BanknoteButton({
  banknote,
  onClick,
  disabled,
  className,
}: {
  banknote: number;
  onClick: () => void;
  disabled: boolean;
  className: string;
}) {
  return (
    <button
      type="button"
      disabled={disabled}
      onClick={onClick}
      className={`inline-flex min-w-0 cursor-pointer items-center justify-center gap-1 border border-pos-line bg-pos-card font-pos-mono font-bold text-pos-ink transition-colors hover:border-pos-ctl active:bg-pos-ready-bg disabled:cursor-not-allowed disabled:opacity-50 ${className}`}
    >
      +{banknote}
      {/* aria-hidden — името на бутона остава „+5" */}
      <span aria-hidden>€</span>
    </button>
  );
}
